import { css } from 'lit';
export default css `
    :host {
        --modal-opacity: 0;
        --modal-pointer-events: none;
        --modal-body-padding: var(--spacing-m);

        --modal-dialog-padding: 0 0 var(--modal-dialog-block-padding) 0;
        --modal-dialog-block-padding: var(--spacing-m);
        --modal-dialog-position: static;
        --modal-dialog-inset-inline-start: auto;
        --modal-dialog-inset-inline-end: auto;
        --modal-dialog-inset-block-start: auto;
        --modal-dialog-inset-block-end: auto;
        --modal-dialog-transform-translate-x: 0;
        --modal-dialog-transform-translate-y: var(--spacing-xs);
        --modal-dialog-min-height: auto;
        --modal-dialog-min-width: auto;
        --modal-dialog-max-height: 100%;
        --modal-dialog-max-width: 30rem;
        --modal-dialog-height: auto;
        --modal-dialog-width: 100%;
        --modal-dialog-radius: var(--radius-l);

        --modal-header-margin: 0;
        --modal-header-padding: var(--spacing-xl) var(--spacing-xxxxl) var(--spacing-xl) var(--spacing-m);

        --modal-heading-padding: 0;

        --modal-content-block-padding: var(--spacing-m);
        --modal-content-inline-padding: var(--spacing-xl);
        --modal-content-padding: var(--modal-content-block-padding) var(--modal-content-inline-padding);
        --modal-content-overflow-y: hidden;
        --modal-content-flex: 1 0 auto;

        --modal-footer-block-padding: var(--spacing-xs);
        --modal-footer-inline-padding: var(--spacing-xl);
        --modal-footer-padding: var(--modal-footer-block-padding) var(--modal-footer-inline-padding);

        display: block;
        pointer-events: var(--modal-pointer-events);
        position: relative;
        z-index: 15;
    }

    :host([visible]) {
        --modal-opacity: 1;
        --modal-dialog-transform-translate-y: 0px;
        --modal-pointer-events: all;
    }

    :host([overflow]) {
        --modal-content-overflow-y: auto;
        --modal-content-flex: 1 1 auto;
    }

    :host([size='auto']) {
        --modal-dialog-max-width: none;
        --modal-dialog-width: auto;
    }

    :host([size='compact']) {
        --modal-dialog-max-width: 22rem;
        --modal-header-inline-end-margin: calc(-1 * var(--spacing-xxs));
        --modal-header-block-padding: 0;
    }

    :host([size='large']) {
        --modal-dialog-max-width: 40rem;
    }

    :host([fullscreen]) {
        --modal-body-padding: 0;
        --modal-content-block-padding: var(--spacing-xl);
        --modal-content-inline-padding: var(--spacing-m);
        --modal-dialog-max-width: none;
        --modal-dialog-width: 100%;
        --modal-dialog-height: 100%;
        --modal-dialog-radius: 0;
    }

    :host([fullscreen]) .surface {
        flex: 1;
    }

    .surface,
    .backdrop {
        opacity: var(--modal-opacity);
    }

    .surface {
        display: flex;
        flex-direction: column;
        flex: var(--modal-content-flex);

        max-height: var(--modal-dialog-max-height);
        max-width: var(--modal-dialog-max-width);
        height: var(--modal-dialog-height);
        width: var(--modal-dialog-width);
        padding: var(--modal-dialog-padding);
        pointer-events: var(--modal-pointer-events);

        outline: 0;
        transition: transform var(--transition-speed), opacity var(--transition-speed);
        transition-timing-function: var(--ease-in-out-quart);
        transform: translate(var(--modal-dialog-transform-translate-x), var(--modal-dialog-transform-translate-y));
        position: var(--modal-dialog-position);

        /* @todo: replace with 'inset' when sufficiently supported (Safari 14.1+) */
        top: var(--modal-dialog-inset-block-start);
        left: var(--modal-dialog-inset-inline-start);
        right: var(--modal-dialog-inset-inline-end);
        bottom: var(--modal-dialog-inset-block-end);

        border-radius: var(--modal-dialog-radius);
    }

    .backdrop {
        background-color: var(--color-backdrop-03);
        transition: opacity var(--transition-speed);
        position: fixed;

        /* @todo: replace with 'inset' when sufficiently supported (Safari 14.1+) */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .body {
        align-items: center;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        overflow: hidden;
        padding: var(--modal-body-padding);
        position: fixed;
        pointer-events: none;
        height: 100%;
        width: 100%;

        /* @todo: replace with 'inset' when sufficiently supported (Safari 14.1+) */
        top: 0;
        left: 0;
    }

    .modal-close {
        position: absolute;
        top: var(--spacing-m);
        right: var(--spacing-m);
    }

    .modal-header {
        flex: 0;
        margin: var(--modal-header-margin);
        padding: var(--modal-header-padding);
    }

    .modal-heading {
        padding: var(--modal-heading-padding);
    }

    .modal-content {
        flex: var(--modal-content-flex);
        overflow-x: hidden;
        overflow-y: var(--modal-content-overflow-y);
        padding: var(--modal-content-padding);
        position: relative;
    }

    .modal-footer {
        flex: 0 0 auto;
        padding: var(--modal-footer-padding);
    }

    .spinner-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: var(--color-ui-08);
    }

    .spinner {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    /* Theme: blue */
    :host([theme='blue']),
    :host([theme='blue']) [tag^='h'] {
        --color: var(--color-ui-08);
    }

    :host([theme='blue']) .modal-close {
        --icon-color: var(--color-ui-08);
    }
`;
